export var ProctorReportStatusEnum;
(function (ProctorReportStatusEnum) {
    ProctorReportStatusEnum["PENDING"] = "PENDING";
    ProctorReportStatusEnum["INPROGRESS"] = "INPROGRESS";
    ProctorReportStatusEnum["FINISHED"] = "FINISHED";
    ProctorReportStatusEnum["PROCESSING"] = "PROCESSING";
    ProctorReportStatusEnum["NOT_QUALIFIED"] = "NOT_QUALIFIED";
})(ProctorReportStatusEnum || (ProctorReportStatusEnum = {}));
export var ProctorReportStatusMLModelEnum;
(function (ProctorReportStatusMLModelEnum) {
    ProctorReportStatusMLModelEnum["PENDING"] = "PENDING";
    ProctorReportStatusMLModelEnum["INPROGRESS"] = "INPROGRESS";
    ProctorReportStatusMLModelEnum["FINISHED"] = "FINISHED";
})(ProctorReportStatusMLModelEnum || (ProctorReportStatusMLModelEnum = {}));
export var VideoModeEnum;
(function (VideoModeEnum) {
    VideoModeEnum["STREAM"] = "STREAM";
    VideoModeEnum["IMAGE"] = "IMAGE";
    VideoModeEnum["MEETING_CAPTURE"] = "MEETING_CAPTURE";
})(VideoModeEnum || (VideoModeEnum = {}));
export var FrameStatusEnum;
(function (FrameStatusEnum) {
    FrameStatusEnum["ERROR"] = "ERROR";
    FrameStatusEnum["PENDING"] = "PENDING";
    FrameStatusEnum["PROCESSING"] = "PROCESSING";
    FrameStatusEnum["FINISHED"] = "FINISHED";
})(FrameStatusEnum || (FrameStatusEnum = {}));
export var ProctorExamStatusEnum;
(function (ProctorExamStatusEnum) {
    ProctorExamStatusEnum["NOT_YET_UPDATED"] = "NOT_YET_UPDATED";
})(ProctorExamStatusEnum || (ProctorExamStatusEnum = {}));
export var SchedulerProctorEnum;
(function (SchedulerProctorEnum) {
    SchedulerProctorEnum["SLOT_MIN_ONE"] = "15";
    SchedulerProctorEnum["SLOT_MIN_TWO"] = "30";
    SchedulerProctorEnum["SLOT_MIN_THREE"] = "45";
    SchedulerProctorEnum["SLOT_MIN_FOUR"] = "59";
})(SchedulerProctorEnum || (SchedulerProctorEnum = {}));
